<template>
  <div class="connect-liveroom-button" @click="handleClick">
    <component
      v-if="showIcon"
      :is="iconName"
      :theme="theme"
      :size="size"
      :fill="fill"
      style="margin-right: 8px; cursor: pointer"
    />
    {{ text }}
  </div>
</template>

<script>
import { Edit, Return, LinkOne, SettingTwo, DownloadFour } from '@icon-park/vue'

export default {
  components: { Edit, Return, LinkOne, SettingTwo, DownloadFour },

  props: {
    text: {
      type: String,
      default: '按钮',
    },
    iconName: {
      type: String,
      default: 'Return',
    },
    theme: {
      type: String,
      default: 'outline',
    },
    size: {
      type: String,
      default: '16',
    },
    fill: {
      type: String,
      default: '#00000045',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="less" scoped>
.connect-liveroom-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px 12px;
}
</style>
